
<template>
      <div class="car-ka car-con">
            <div class="car-large" :class="carno?'car-large-no':''">
                <div class="swiper-container">
                    <!-- <div class="swiper-wrapper"> -->
                        <swiper :options="swiperOption" class="swiper-wrapper" ref="mySwiper">
                                <swiper-slide class="swiper-slide" v-for="(item,index) in carddata" :key="index">
                                    <img class="pg" :src="'//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/card'+item.indexka+'.png'" />
                                    <a data-stat="立即开奖" v-if="item.cardStatus==0&&item.indexka!='13'&&item.indexka!='14'&&item.indexka!='15'" :data-cardNo="item.cardNo" class="lijiang" @click="takeBoxcha(item.cardNo,item.channel)" href="javascript:void(0);"></a>
                                    <a data-stat="查看奖励" class="di1" v-if="item.cardStatus==1&&item.indexka!='13'&&item.indexka!='14'&&item.indexka!='15'" :href="juanlink"></a>
                                    <a data-stat="一分购" class="hcheng" v-if="item.indexka==15&&item.indexka!='13'" :href="yifenlink"></a>
                                    <a data-stat="锦鲤奖" class="jinli" v-if="item.indexka==14&&item.indexka!='13'" :href="jinlilink"></a>
                                </swiper-slide>
                                <div class="swiper-slide js-carno" v-if="carno">
                                <img src="//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/card0.png">
                                </div>
                        </swiper>
                    <div data-stat="查看卡片_左" class="swiper-button-prev"></div>
                    <div data-stat="查看卡片_右" class="swiper-button-next"></div>
                   
                </div>
            </div>
            <div class="car-Small">
                <ul class="clearfix">
                    <li v-for="(item,index) in cardnolist" :key="index" :data-cad="index" >
                        <a @click="choukato(item.taget)" :data-stat="'小卡_卡'+item.inde" :data-tagat="item.taget" href="javascript:void(0);" :class="item.status">
                            <img :src="'//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/car'+item.ifget+'_'+item.inde+'.png'" alt="">
                            <i v-if="item.totalNums>1">{{item.totalNums}}</i>
                        </a>
                    </li>
                </ul>
                <div class="car-an">
                    <a ata-stat="合成卡片" v-if="synthesis&&!hchengka" @click="combinationcard" class="hc" href="javascript:void(0);"></a>
                    <a data-stat="去一分购" v-if="hchengka" class="hc yifen" :href="yifenlink"></a>
                    <a data-stat="领取我的卡皮" v-if="activityTimes>0" @click="chouka" class="car-lin" href="javascript:void(0);"><span v-if="activityTimes>0">{{activityTimes}}</span></a>
                    <a v-if="activityTimes<=0" class="car-lin car-lin-no" href="javascript:void(0);"></a>
                    <a v-if="jinliif" data-stat="锦鲤奖" class="jinli" :href="jinlilink"></a>
                </div>

            </div>
        </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  props:['carddata','carno','hchengka','synthesis','activityTimes','cardnolist','juanlink','yifenlink','jinliif','jinlilink'], 
  data () {
      return {
        swiperOption:{
        slidesPerView: 3,
        spaceBetween:-14,
        centeredSlides: true,
        initialSlide:0,
        loop: false,
        observer: true,
        observeSlideChildren:true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        }
      }
    },
    created(){
      
    }, 
    computed:{
        swiper() {  
            return this.$refs.mySwiper.swiper;  
        } 
    },
    methods:{
          chouka(){
              this.$parent.getka();
          },
          takeBoxcha(activityCode,channelka){
              this.$parent.takeBox(activityCode,channelka);
          },
          combinationcard(){
              this.$parent.hccombine();
          },
          choukato(tagat){
            if(event.currentTarget.className=='over'){
                return;
            }else{
                 if(tagat>=0){
                    this.swiper.slideTo(tagat, 500, false);
                }
            }
          }

    },
    mounted(){
         
    },
     components:{
      swiper,
      swiperSlide
    }
  
}
</script>

<style scoped>
.car-con{
    width: 100%;
    overflow: hidden;
    padding-bottom: .5rem;
}
.car-con .title{
    width: 100%;
    text-align: center;
}
.car-con .title img{
    height: .61rem;
    width:auto;
    display: inline-block;
}
/* 大卡展示 */
.car-large{
    display: block;
    width: 148%;
    height: 5.18rem;
    position: relative;
    -webkit-transform: translateX(-16.5%);
    -moz-transform: translateX(-16.5%);
    -ms-transform: translateX(-16.5%);
    -o-transform: translateX(-16.5%);
    transform: translateX(-16.5%);
    margin-top: .36rem;
}
.car-large .swiper-container{
    height: 100%;
    overflow: inherit;
}
.car-large .swiper-container .swiper-slide {
    text-align: center;
    font-size: 18px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    transition: 300ms;
    transform: scale(0.8);
    border-radius: .18rem;
    box-shadow: .12rem .14rem .34rem #31003a;
}
.car-large.car-large-no .swiper-container .swiper-slide{
    box-shadow: none;
}
.car-large .swiper-container .swiper-slide-active,.car-large .swiper-container .swiper-slide-duplicate-active {
    transform: scale(1);
}
.car-large .swiper-button-next,.car-large .swiper-button-prev{
    width: .69rem;
    height: .88rem;
    background: url(//i1.ulecdn.com/i/event/2018/0511/card/cr.png) no-repeat center;
    background-size: 100% 100%;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    margin-top: 0;
}
.car-large .swiper-button-prev,.car-large .swiper-container-rtl .swiper-button-next{
    background: url(//i1.ulecdn.com/i/event/2018/0511/card/cl.png) no-repeat center;
    background-size: 100% 100%;
    left: 25%;
}
.car-large .swiper-button-next.swiper-button-disabled,.car-large .swiper-button-prev.swiper-button-disabled{
    opacity: 1;
}
.car-large .swiper-button-next,.car-large .swiper-container-rtl .swiper-button-prev{
    background: url(//i1.ulecdn.com/i/event/2018/0511/card/cr.png) no-repeat center;
    background-size: 100% 100%;
    right:25%;
}
.swiper-slide-prev:before,.swiper-slide-next:before{
    content: '';
    width: 100%;
    height: 100%;
    display: block;
    position: absolute;
    top: 0;
    left:0;
    background-color:rgba(49,0,84,.7);
    border-radius: .18rem;
    z-index: 5;
}
.car-large .swiper-slide .di1{
    display: block;
    top: 85%;
    width: 72%;
    height: .76rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/an8.png) no-repeat center;
    background-size: 100% 100%;
    z-index: 4;
    position: absolute;
    left: 14%;
}
.swiper-button-next:after, .swiper-button-prev:after {
   display: none;
}
/* 卡片区域 */
.car-Small{
    display: block;
    height:6.55rem;
    width: 100%;
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/bg2.png) no-repeat center;
    background-size: 100% 100%;
    margin: 0 auto;
    margin-top: .24rem;
    padding: .28rem .28rem;
    position: relative;
    box-sizing: border-box
}
.car-Small ul{
    display: block;
    width: 100%;
    text-align: center;
    padding: 7.5% 4% 0;
    box-sizing: border-box;
}
.car-Small ul li{
    width: 14.6%;
    float: left;
    margin-right: 2.4%;
    margin-bottom: 3.8%;
    position: relative;
    height: 1.19rem;
}
.car-Small ul li a,.car-Small ul li a img{
    display: block;
    width: 100%;
}
.car-Small ul li a i{
    display: block;
    position: absolute;
    top: -.06rem;
    right: -.06rem;
    color: #fef3a7;
    background-color: #e03c34;
    border: 1px solid #fff3a5;
    font-size: .2rem;
    border-radius: .14rem;
    padding: .01rem .07rem;
}
.car-Small ul li:nth-of-type(5),.car-Small ul li:nth-of-type(11){
    margin-right: 0;
}
.car-Small ul li:nth-of-type(6){
    float: right;
    margin-right: 0;
}
.car-Small ul li:nth-of-type(12){
    float: right;
    margin-right: 0;
}
.car-Small ul li:nth-of-type(13),
.car-Small ul li:nth-of-type(14),
.car-Small ul li:nth-of-type(15){
    width: 33.33%;
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jz.png)no-repeat center;
    height: 1.66rem;
    background-size: 1.9rem 1.57rem;
    text-align: center;
    margin: 0;
}
.car-Small ul li:nth-of-type(13) img,
.car-Small ul li:nth-of-type(14) img,
.car-Small ul li:nth-of-type(15) img{
    display:inline-block;
    width: 53%;
}
.car-Small .car-an{
    display: block;
    position: absolute;
    width: 100%;
    bottom: -1.5%;
    left: 0;
    height: .94rem;
    text-align: center;
}
.car-Small .hc{
    display: inline-block;
    width: 23%;
    height: .74rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/an5.png) no-repeat center;
    background-size: 100% 100%;
    margin-right: .15rem;
}
.car-Small .jinli{
    display: inline-block;
    width: 23%;
    height: .74rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/an4.png) no-repeat center;
    background-size: 100% 100%;
    margin-left: .15rem;
}
.car-Small .hc.yifen{
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/an3.png) no-repeat center;
    background-size: 100% 100%;
}
.car-lin{
    display:inline-block;
    width: 23%;
    height: .74rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/an2.png) no-repeat center;
    background-size: 100% 100%;
    position: relative;
}
.car-lin.car-lin-no{
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/an1.png) no-repeat center;
    background-size: 100% 100%;
}
.swiper-slide .zi, .swiper-slide .pai, .swiper-slide .pd, .swiper-slide .lijiang, .ka-conten .zi, .ka-conten .pai, .ka-conten .pd, .ka-conten .lijiang {
    height: auto;
    display: block;
    position: absolute;
    left: 50%;
    -webkit-transform: translateX(-50%);
    -moz-transform: translateX(-50%);
    -ms-transform: translateX(-50%);
    -o-transform: translateX(-50%);
    transform: translateX(-50%);
}
.swiper-slide .zi,.swiper-slide .pai,.swiper-slide .pd,.swiper-slide .hcheng,
.ka-conten .zi,.ka-conten .pai,.ka-conten .pd,.ka-conten .hcheng
{
    position: absolute;
    top: 85%;
    width: 72%;
    height: .76rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/an9.png) no-repeat center;
    background-size: 100% 100%;
    z-index: 4;
    left: 14%;
    display: block;
}
.swiper-slide .jinli{
    position: absolute;
    top: 85%;
    width: 72%;
    height: .76rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/an7.png) no-repeat center;
    background-size: 100% 100%;
    z-index: 4;
    left: 14%;
    display: block;
}
.ka-conten .jinli{
    position: absolute;
    top: 85%;
    width: 72%;
    height: .76rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/an7.png) no-repeat center;
    background-size: 100% 100%;
    z-index: 4;
    left: 14%;
    display: block;
}
.swiper-slide .lijiang{
    display: block;
    top: 85%;
    width: 72%;
    height: .76rem;
    background: url(//www.ule.com/app/yxd/event/2019/0730/twelve/images/jika/an6.png) no-repeat center;
    background-size: 100% 100%;
    z-index: 4;
    position: absolute;
    left: 50%;
}
.car-lin span {
    display: block;
    position: absolute;
    top: .08rem;
    right: .06rem;
    color: #fef3a7;
    background-color: #e03c34;
    border: 1px solid #fff3a5;
    font-size: .2rem;
    border-radius: .14rem;
    padding: .01rem .07rem;
}
</style>



// WEBPACK FOOTER //
// src/components/common/Carddisplay.vue